(() => {
  'use strict';
  document.querySelectorAll('[data-ss-share]').forEach(root => {
    if(root.dataset.shareReady) return;
    root.dataset.shareReady = 'true';
    const dialog = root.querySelector('dialog'), input = root.querySelector('[data-ss-share-link]'), status = root.querySelector('[data-ss-share-status]');
    const open = root.querySelector('[data-ss-share-open]');
    function shareData() {
      const url = new URL(root.dataset.url);
      const id = root.closest('section')?.querySelector('[data-u7-variant], [data-range-variant], [data-variant]');
      if (id && !id.disabled && /^\d+$/.test(id.value)) url.searchParams.set('variant', id.value);
      return {title:root.dataset.title, text:'Take a closer look at this SOTHING product.', url:url.href};
    }
    function syncLinks() {
      const data = shareData(); input.value = data.url;
      root.querySelectorAll('[data-ss-x]').forEach(a => a.href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(data.title) + '&url=' + encodeURIComponent(data.url));
      root.querySelectorAll('[data-ss-facebook]').forEach(a => a.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(data.url));
      const image = new URL(root.dataset.image || document.querySelector('meta[property="og:image"]')?.content || '', location.href).href;
      root.querySelectorAll('[data-ss-pinterest]').forEach(a => a.href = 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(data.url) + '&media=' + encodeURIComponent(image) + '&description=' + encodeURIComponent(data.title));
      root.querySelector('[data-ss-email]').href = 'mailto:?subject=' + encodeURIComponent(data.title) + '&body=' + encodeURIComponent(data.text+'\n'+data.url);
      root.querySelector('[data-ss-native]').hidden = typeof navigator.share !== 'function';
    }
    syncLinks();
    root.querySelectorAll('a[target="_blank"], [data-ss-email]').forEach(a => a.addEventListener('click', syncLinks));
    document.addEventListener('change', syncLinks);
    open.addEventListener('click', () => {
      syncLinks(); status.textContent = '';
      dialog.showModal();
    });
    root.querySelectorAll('[data-ss-copy]').forEach(button => button.addEventListener('click', async () => {
      syncLinks();
      const feedback = dialog.open ? status : root.querySelector('[data-ss-inline-status]');
      try { await navigator.clipboard.writeText(input.value); feedback.textContent = 'Link copied. Ready to send.'; }
      catch { if (!dialog.open) dialog.showModal(); input.focus(); input.select(); status.textContent = 'Select and copy the product link above.'; }
    }));
    root.querySelector('[data-ss-native]').addEventListener('click', async () => {
      try { await navigator.share(shareData()); status.textContent = 'Returned from device sharing.'; }
      catch (error) { status.textContent = error.name === 'AbortError' ? 'Sharing cancelled. Your setup is unchanged.' : 'Device sharing is unavailable. You can copy the link instead.'; }
    });
    root.querySelector('[data-ss-share-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) { const b=dialog.getBoundingClientRect(); if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close(); } });
    dialog.addEventListener('close', () => open.focus({preventScroll:true}));
  });
})();
